(function () {
  var marker = 'trouser-tshirt-20260924';
  var legacyMarker = 'trouser-tshirt-2026';
  var optOutStorageKey = 'ff-free-tshirt-opt-out-20260924';
  var expiryRefreshStorageKey = 'ff-free-tshirt-expiry-refresh-20260924';
  var removingGifts = false;
  var sizeOrder = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL'];
  var busy = false;
  var memoryOptOut = false;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function route(path) {
    return root() + path.replace(/^\//, '');
  }

  function parseKeys(value) {
    return (value || '').split('||').filter(Boolean);
  }

  function readOptOut() {
    try {
      return window.sessionStorage.getItem(optOutStorageKey) === 'true' || memoryOptOut;
    } catch (error) {
      return memoryOptOut;
    }
  }

  function writeOptOut(value) {
    memoryOptOut = Boolean(value);
    try {
      if (value) {
        window.sessionStorage.setItem(optOutStorageKey, 'true');
      } else {
        window.sessionStorage.removeItem(optOutStorageKey);
      }
    } catch (error) {
      memoryOptOut = Boolean(value);
    }
  }

  function isHistoryNavigation() {
    var navigationEntry = window.performance &&
      typeof window.performance.getEntriesByType === 'function' &&
      window.performance.getEntriesByType('navigation')[0];
    return navigationEntry && navigationEntry.type === 'back_forward';
  }

  function hasEnded(picker) {
    var end = Date.parse(picker.dataset.endAt || '');
    return Number.isFinite(end) && Date.now() >= end;
  }

  function isEligiblePicker(picker) {
    return picker && !hasEnded(picker) && picker.dataset.active === 'true' && picker.dataset.hasQualifier === 'true';
  }

  function needsGiftRemoval(picker) {
    return (picker.dataset.hasMarkedGift === 'true' || parseKeys(picker.dataset.markedKeys).length > 0) &&
      (!isEligiblePicker(picker) || picker.dataset.checkoutSafe !== 'true');
  }

  function isPickerOptedOut(picker) {
    return isEligiblePicker(picker) && picker.dataset.checkoutSafe !== 'true' && readOptOut();
  }

  async function requestJson(url, options) {
    var response = await fetch(url, options || {});
    var data;
    try {
      data = await response.json();
    } catch (error) {
      data = {};
    }
    if (!response.ok) {
      var message = data.description || data.message;
      var requestError = new Error(message || '');
      requestError.status = response.status;
      throw requestError;
    }
    return data;
  }

  async function getCart() {
    return requestJson(route('cart.js'), { cache: 'no-store', headers: { Accept: 'application/json' } });
  }

  async function changeLine(key, quantity) {
    return requestJson(route('cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    });
  }

  async function removeMarkedKeys(keys) {
    for (var i = 0; i < keys.length; i += 1) {
      await changeLine(keys[i], 0);
    }
  }

  function markedCartItems(cart) {
    if (!cart || !Array.isArray(cart.items)) throw new Error('');
    return cart.items.filter(function (item) {
      return item.properties && (item.properties._ff_promo_gift === marker || item.properties._ff_promo_gift === legacyMarker);
    });
  }

  async function removeAllMarkedGifts() {
    var marked = markedCartItems(await getCart());
    var remaining = marked.length;
    while (marked.length && remaining > 0) {
      await changeLine(marked[0].key, 0);
      marked = markedCartItems(await getCart());
      remaining -= 1;
    }
    if (marked.length) throw new Error('');
  }

  function showRemovalStatusOnAll(error) {
    document.querySelectorAll('ff-free-tshirt').forEach(function (picker) {
      if (needsGiftRemoval(picker) && typeof picker.showRemovalStatus === 'function') {
        picker.showRemovalStatus(error);
        picker.setBusy(true);
      }
    });
  }

  function discountMatches(item, title) {
    var discounts = item.discounts || item.line_level_discount_allocations || [];
    return discounts.some(function (discount) {
      var candidate = discount.title || (discount.discount_application && discount.discount_application.title);
      return candidate === title;
    });
  }

  async function refreshSurfaces(openDrawer) {
    var cartPath = route('cart').split('?')[0].replace(/\/+$/, '');
    var currentPath = window.location.pathname.replace(/\/+$/, '');
    if (currentPath === cartPath) {
      window.location.reload();
      return;
    }

    var names = ['cart-drawer', 'cart-icon-bubble', 'main-cart'];
    var response = await requestJson(route('?sections=' + names.join(',')));

    var drawer = document.querySelector('cart-drawer');
    var currentMainCart = document.querySelector('cart-items.main-cart');
    if ((drawer && (typeof response['cart-drawer'] !== 'string' || !response['cart-drawer'].trim())) ||
        (currentMainCart && (typeof response['main-cart'] !== 'string' || !response['main-cart'].trim()))) {
      throw new Error('');
    }
    if (drawer && response['cart-drawer'] && typeof drawer.renderContents === 'function') {
      drawer.renderContents({ id: null, sections: response });
      if (!openDrawer && typeof drawer.close === 'function') drawer.close();
    } else if (response['cart-drawer']) {
      var drawerDoc = new DOMParser().parseFromString(response['cart-drawer'], 'text/html');
      var nextDrawer = drawerDoc.querySelector('cart-drawer');
      if (drawer && nextDrawer) drawer.replaceWith(nextDrawer);
    }

    if (response['cart-icon-bubble']) {
      var iconDoc = new DOMParser().parseFromString(response['cart-icon-bubble'], 'text/html');
      var currentIconSection = document.getElementById('shopify-section-cart-icon-bubble');
      var nextIconSection = iconDoc.getElementById('shopify-section-cart-icon-bubble');
      if (currentIconSection && nextIconSection) currentIconSection.innerHTML = nextIconSection.innerHTML;
    }

    if (response['main-cart']) {
      var cartDoc = new DOMParser().parseFromString(response['main-cart'], 'text/html');
      var currentCart = document.querySelector('cart-items.main-cart');
      var nextCart = cartDoc.querySelector('cart-items.main-cart');
      if (currentCart && nextCart) currentCart.replaceWith(nextCart);
    }

    updateAllPickerStates();
  }

  function pickerNeedsDecision(picker) {
    return busy || needsGiftRemoval(picker) || (isEligiblePicker(picker) && picker.dataset.checkoutSafe !== 'true' && !isPickerOptedOut(picker));
  }

  function unsafePicker() {
    return Array.from(document.querySelectorAll('ff-free-tshirt')).find(pickerNeedsDecision) || null;
  }

  function addStatusDescription(control, statusId) {
    if (!statusId) return;
    var values = (control.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
    if (!values.includes(statusId)) values.push(statusId);
    control.setAttribute('aria-describedby', values.join(' '));
    control.dataset.ffStatusDescription = statusId;
  }

  function removeStatusDescription(control) {
    var statusId = control.dataset.ffStatusDescription;
    if (!statusId) return;
    var values = (control.getAttribute('aria-describedby') || '').split(/\s+/).filter(function (value) {
      return value !== statusId;
    });
    if (values.length) {
      control.setAttribute('aria-describedby', values.join(' '));
    } else {
      control.removeAttribute('aria-describedby');
    }
    delete control.dataset.ffStatusDescription;
  }

  function disableCheckout(control, picker) {
    if (control.getAttribute('data-ff-disabled-by-promo') !== 'true') {
      control.dataset.ffPreviousAriaDisabled = control.getAttribute('aria-disabled') || '';
      control.dataset.ffPreviousTitle = control.getAttribute('title') || '';
      if ('disabled' in control) control.dataset.ffPreviousDisabled = control.disabled ? 'true' : 'false';
    }
    control.setAttribute('aria-disabled', 'true');
    control.setAttribute('data-ff-disabled-by-promo', 'true');
    if ('disabled' in control) control.disabled = true;
    control.title = needsGiftRemoval(picker) ? picker.dataset.removeError : (picker.dataset.checkoutBlocked || picker.dataset.choiceRequiredStatus || '');
    addStatusDescription(control, picker.status?.id);
  }

  function enableCheckout(control) {
    if (control.getAttribute('data-ff-disabled-by-promo') !== 'true') return;
    if (control.dataset.ffPreviousAriaDisabled) {
      control.setAttribute('aria-disabled', control.dataset.ffPreviousAriaDisabled);
    } else {
      control.removeAttribute('aria-disabled');
    }
    if ('disabled' in control) control.disabled = control.dataset.ffPreviousDisabled === 'true';
    if (control.dataset.ffPreviousTitle) {
      control.title = control.dataset.ffPreviousTitle;
    } else {
      control.removeAttribute('title');
    }
    removeStatusDescription(control);
    control.removeAttribute('data-ff-disabled-by-promo');
    delete control.dataset.ffPreviousAriaDisabled;
    delete control.dataset.ffPreviousDisabled;
    delete control.dataset.ffPreviousTitle;
  }

  function guardCheckout() {
    var picker = unsafePicker();
    var controls = document.querySelectorAll('cart-drawer button[name="checkout"], cart-items button[name="checkout"], cart-drawer a[href*="/checkout"], cart-items a[href*="/checkout"]');
    controls.forEach(function (control) {
      if (picker) {
        disableCheckout(control, picker);
      } else {
        enableCheckout(control);
      }
    });
    document.querySelectorAll('.cart__dynamic-checkout-buttons').forEach(function (control) {
      if (picker) {
        if (control.dataset.ffHiddenByPromo !== 'true') control.dataset.ffPreviousHidden = String(control.hidden);
        control.dataset.ffHiddenByPromo = 'true';
        control.hidden = true;
      } else if (control.dataset.ffHiddenByPromo === 'true') {
        control.hidden = control.dataset.ffPreviousHidden === 'true';
        delete control.dataset.ffHiddenByPromo;
        delete control.dataset.ffPreviousHidden;
      }
    });
  }

  function updateAllPickerStates() {
    document.querySelectorAll('ff-free-tshirt').forEach(function (picker) {
      if (typeof picker.syncState === 'function') picker.syncState();
    });
    guardCheckout();
  }

  document.addEventListener('click', function (event) {
    var checkout = event.target.closest('cart-drawer button[name="checkout"], cart-items button[name="checkout"], cart-drawer a[href*="/checkout"], cart-items a[href*="/checkout"]');
    var picker = unsafePicker();
    if (!checkout || !picker) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (needsGiftRemoval(picker)) picker.reconcile();
    else picker.setStatus(picker.dataset.choiceRequiredStatus, true);
    picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
    window.setTimeout(function () {
      (picker.querySelector('[data-ff-gift-model][tabindex="0"]:not(:disabled)') || picker.querySelector('[data-ff-gift-model]:not(:disabled)') || picker.querySelector('.ff-free-tshirt__select:not(:disabled)') || picker.querySelector('[data-ff-gift-retry]:not(:disabled)') || picker.querySelector('[data-ff-gift-skip]:not(:disabled)'))?.focus();
    }, 300);
  }, true);

  document.addEventListener('submit', function (event) {
    if (!event.target.matches('#cart, #CartDrawer-Form')) return;
    if (event.submitter && event.submitter.name !== 'checkout') return;
    var picker = unsafePicker();
    if (!picker) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (needsGiftRemoval(picker)) picker.reconcile();
    else picker.setStatus(picker.dataset.choiceRequiredStatus, true);
    picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, true);

  class FFFreeTshirt extends HTMLElement {
    connectedCallback() {
      this.initialActiveAtExpiry = this.dataset.active === 'true' && hasEnded(this);
      this.button = this.querySelector('[data-ff-gift-add]');
      this.skipButton = this.querySelector('[data-ff-gift-skip]');
      this.select = this.querySelector('[data-ff-gift-source]') || this.querySelector('.ff-free-tshirt__select');
      this.status = this.querySelector('.ff-free-tshirt__status');
      this.recovery = this.querySelector('[data-ff-gift-recovery]');
      this.retryButton = this.querySelector('[data-ff-gift-retry]');
      if (this.retryButton) this.retryButton.addEventListener('click', this.reconcile.bind(this));
      // A history-restored page can reconnect stale, empty cart markup before
      // cart-drawer.js replaces it with the current server-rendered sections.
      // Do not erase an explicit session opt-out from that temporary state.
      if (!isHistoryNavigation() && (!isEligiblePicker(this) || this.dataset.checkoutSafe === 'true')) {
        writeOptOut(false);
      }
      if (this.button) this.button.addEventListener('click', this.addGift.bind(this));
      if (this.skipButton) this.skipButton.addEventListener('click', this.skipGift.bind(this));
      if (this.select) this.select.addEventListener('change', this.onSelectionChange.bind(this));
      this.setupGallery();
      this.syncState();
      this.reconcile();
      this.scheduleEnd();
      guardCheckout();
    }

    // Progressive enhancement: replaces the flat text dropdown with image
    // tiles for the model plus a size dropdown. The original select stays in
    // the DOM as the single source of truth for addGift(), so if this setup
    // bails out for any reason the plain dropdown remains fully usable.
    setupGallery() {
      var enhanced = this.querySelector('[data-ff-gift-enhanced]');
      var fallback = this.querySelector('[data-ff-gift-fallback]');
      var sizeSelect = this.querySelector('[data-ff-gift-size]');
      var tiles = Array.prototype.slice.call(this.querySelectorAll('[data-ff-gift-model]'));
      if (!enhanced || !fallback || !sizeSelect || !this.select || !tiles.length) return;

      var groups = {};
      Array.prototype.slice.call(this.select.options).forEach(function (option) {
        if (!option.value || !option.dataset.model) return;
        if (!groups[option.dataset.model]) groups[option.dataset.model] = [];
        groups[option.dataset.model].push({
          value: option.value,
          label: option.dataset.size || option.textContent.trim()
        });
      });
      if (!Object.keys(groups).length) return;

      // Shopify returns the variants in creation order, which reads as
      // "L, M, S". Put them in wearing order; anything unrecognised keeps
      // its original position at the end.
      Object.keys(groups).forEach(function (handle) {
        groups[handle].sort(function (a, b) {
          var indexA = sizeOrder.indexOf(String(a.label).trim().toUpperCase());
          var indexB = sizeOrder.indexOf(String(b.label).trim().toUpperCase());
          if (indexA === -1 && indexB === -1) return 0;
          if (indexA === -1) return 1;
          if (indexB === -1) return -1;
          return indexA - indexB;
        });
      });

      var self = this;
      var placeholder = sizeSelect.dataset.placeholder || '';
      this.gallery = { sizeSelect: sizeSelect, tiles: tiles, sizeWasDisabled: true };

      enhanced.hidden = false;
      fallback.hidden = true;

      function renderSizes(handle, keepValue) {
        var items = groups[handle] || [];
        sizeSelect.innerHTML = '';
        var blank = document.createElement('option');
        blank.value = '';
        blank.textContent = placeholder;
        sizeSelect.appendChild(blank);
        items.forEach(function (item) {
          var option = document.createElement('option');
          option.value = item.value;
          option.textContent = item.label;
          sizeSelect.appendChild(option);
        });
        sizeSelect.disabled = items.length === 0;
        self.gallery.sizeWasDisabled = sizeSelect.disabled;
        if (keepValue && items.some(function (item) { return item.value === keepValue; })) {
          sizeSelect.value = keepValue;
        } else if (items.length === 1) {
          sizeSelect.value = items[0].value;
        }
      }

      function markTiles(handle) {
        tiles.forEach(function (tile, index) {
          var on = tile.dataset.ffGiftModel === handle;
          tile.classList.toggle('is-selected', on);
          tile.setAttribute('aria-checked', on ? 'true' : 'false');
          tile.setAttribute('tabindex', on || (!handle && index === 0) ? '0' : '-1');
        });
      }

      function pushToSelect() {
        self.select.value = sizeSelect.value || '';
        self.select.dispatchEvent(new Event('change', { bubbles: true }));
      }

      function isTileEnabled(tile) {
        return !tile.disabled && tile.getAttribute('aria-disabled') !== 'true';
      }

      function selectTile(tile, focusSize) {
        if (!isTileEnabled(tile)) return;
        var keepValue = tile.getAttribute('aria-checked') === 'true' ? sizeSelect.value : '';
        markTiles(tile.dataset.ffGiftModel);
        renderSizes(tile.dataset.ffGiftModel, keepValue);
        pushToSelect();
        if (focusSize && !sizeSelect.disabled && !sizeSelect.value) sizeSelect.focus();
      }

      tiles.forEach(function (tile) {
        tile.addEventListener('click', function () {
          selectTile(tile, true);
        });
        tile.addEventListener('keydown', function (event) {
          if (!isTileEnabled(tile) || event.altKey || event.ctrlKey || event.metaKey) return;
          var enabledTiles = tiles.filter(isTileEnabled);
          var index = enabledTiles.indexOf(tile);
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
            index = (index + 1) % enabledTiles.length;
          } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
            index = (index - 1 + enabledTiles.length) % enabledTiles.length;
          } else if (event.key === 'Home') {
            index = 0;
          } else if (event.key === 'End') {
            index = enabledTiles.length - 1;
          } else {
            return;
          }
          event.preventDefault();
          selectTile(enabledTiles[index], false);
          enabledTiles[index].focus();
        });
      });

      sizeSelect.addEventListener('change', pushToSelect);

      var current = this.select.value;
      var currentOption = current ? this.select.querySelector('option[value="' + current + '"]') : null;
      if (currentOption && currentOption.dataset.model) {
        markTiles(currentOption.dataset.model);
        renderSizes(currentOption.dataset.model, current);
      } else {
        markTiles('');
      }
    }

    setBusy(value) {
      if (this.retryButton) this.retryButton.disabled = value;
      if (this.button) this.button.disabled = value || hasEnded(this);
      if (this.skipButton) this.skipButton.disabled = value;
      if (this.select) this.select.disabled = value;
      if (this.gallery) {
        this.gallery.tiles.forEach(function (tile) { tile.disabled = value; });
        this.gallery.sizeSelect.disabled = value ? true : Boolean(this.gallery.sizeWasDisabled);
      }
      this.setAttribute('aria-busy', value ? 'true' : 'false');
    }

    setStatus(message, error, success) {
      if (!this.status) return;
      this.status.textContent = message || '';
      this.status.classList.toggle('ff-free-tshirt__error', Boolean(error));
      this.status.classList.toggle('ff-free-tshirt__success', Boolean(success));
      this.status.setAttribute('role', error ? 'alert' : 'status');
    }

    syncState() {
      if (this.recovery && !this.recovery.hidden) return;
      if (hasEnded(this)) {
        this.dataset.active = 'false';
        this.classList.add('ff-free-tshirt--inactive');
        this.setBusy(false);
        return;
      }
      var optedOut = isPickerOptedOut(this);
      this.classList.toggle('ff-free-tshirt--opted-out', optedOut);
      if (this.skipButton) this.skipButton.classList.toggle('is-selected', optedOut);
      if (optedOut) {
        this.setStatus(this.dataset.optedOutStatus, false, true);
      } else if (this.dataset.checkoutSafe === 'true') {
        this.setStatus(this.dataset.selectedStatus, false, true);
      } else if (this.dataset.hasMarkedGift === 'true') {
        this.setStatus(this.dataset.invalidStatus, true, false);
      } else if (isEligiblePicker(this)) {
        this.setStatus(this.dataset.choiceRequiredStatus, false, false);
      }
    }

    onSelectionChange() {
      if (!this.select.value) {
        if (this.dataset.checkoutSafe === 'true') {
          this.setStatus(this.dataset.currentGiftKeptStatus, false, true);
        } else {
          this.syncState();
        }
        return;
      }
      if (Number(this.select.value) === Number(this.dataset.markedVariant || 0) && this.dataset.checkoutSafe === 'true') {
        this.setStatus(this.dataset.selectedStatus, false, true);
        return;
      }
      this.setStatus(this.dataset.applySelectionStatus, false, false);
    }

    scheduleEnd() {
      var end = Date.parse(this.dataset.endAt || '');
      if (!Number.isFinite(end)) return;
      var delay = end - Date.now();
      var self = this;
      var staleActive = this.initialActiveAtExpiry || (delay <= 0 && this.dataset.active === 'true');
      function endCampaign() {
        if (!document.contains(self)) return;
        self.syncState();
        guardCheckout();
        if (needsGiftRemoval(self)) self.reconcile();
        else if (delay > 0) window.location.reload();
        else if (staleActive) {
          try {
            if (window.sessionStorage.getItem(expiryRefreshStorageKey) === self.dataset.endAt) return;
            window.sessionStorage.setItem(expiryRefreshStorageKey, self.dataset.endAt);
            if (window.sessionStorage.getItem(expiryRefreshStorageKey) === self.dataset.endAt) window.location.reload();
          } catch (error) {
            return;
          }
        }
      }
      if (delay <= 0) endCampaign();
      else if (delay < 2147483647) window.setTimeout(endCampaign, delay + 250);
    }

    async reconcile() {
      if (!needsGiftRemoval(this)) return;
      if (busy) {
        if (removingGifts) {
          this.showRemovalStatus(false);
          this.setBusy(true);
        }
        return;
      }
      busy = true;
      removingGifts = true;
      showRemovalStatusOnAll(false);
      guardCheckout();
      try {
        await removeAllMarkedGifts();
        await refreshSurfaces(this.dataset.surface === 'drawer');
      } catch (error) {
        showRemovalStatusOnAll(true);
        guardCheckout();
      } finally {
        busy = false;
        removingGifts = false;
        document.querySelectorAll('ff-free-tshirt').forEach(function (picker) {
          if (typeof picker.setBusy === 'function') picker.setBusy(false);
        });
        guardCheckout();
      }
    }

    showRemovalStatus(error) {
      if (!this.recovery) return;
      Array.from(this.children).forEach(function (child) { child.hidden = true; });
      this.recovery.hidden = false;
      this.classList.remove('ff-free-tshirt--inactive');
      this.status = this.recovery.querySelector('.ff-free-tshirt__status');
      this.setStatus(error ? this.dataset.removeError : this.dataset.removingStatus, error, false);
    }

    async skipGift() {
      if (busy) return;
      var keys = parseKeys(this.dataset.markedKeys);
      if (!keys.length) {
        writeOptOut(true);
        updateAllPickerStates();
        return;
      }

      busy = true;
      this.setBusy(true);
      guardCheckout();
      this.setStatus(this.dataset.removingStatus, false, false);
      try {
        await removeAllMarkedGifts();
        writeOptOut(true);
        await refreshSurfaces(this.dataset.surface === 'drawer');
      } catch (error) {
        writeOptOut(false);
        this.setStatus(error.message || this.dataset.removeError, true, false);
        guardCheckout();
      } finally {
        busy = false;
        if (document.contains(this)) this.setBusy(false);
        guardCheckout();
      }
    }

    async addGift() {
      if (busy) return;
      if (needsGiftRemoval(this)) {
        await this.reconcile();
        return;
      }
      if (!isEligiblePicker(this)) {
        this.syncState();
        guardCheckout();
        await this.reconcile();
        return;
      }
      if (!this.select || !this.select.value) {
        this.setStatus(this.dataset.selectFirstStatus, true, false);
        return;
      }

      var selectedId = Number(this.select.value);
      var existingId = Number(this.dataset.markedVariant || 0);
      writeOptOut(false);
      updateAllPickerStates();
      if (selectedId && selectedId === existingId && this.dataset.checkoutSafe === 'true') {
        this.setStatus(this.dataset.alreadySelectedStatus, false, true);
        return;
      }

      busy = true;
      this.setBusy(true);
      guardCheckout();
      this.setStatus(this.dataset.checkingStatus, false, false);
      var oldKeys = parseKeys(this.dataset.markedKeys);

      try {
        await requestJson(route('cart/add.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{
              id: selectedId,
              quantity: 1,
              properties: { _ff_promo_gift: marker }
            }]
          })
        });

        if (hasEnded(this)) throw new Error('');
        if (oldKeys.length && selectedId !== existingId) await removeMarkedKeys(oldKeys);

        var cart = await getCart();
        var marked = markedCartItems(cart);
        var exactDiscount = isEligiblePicker(this) && marked.length === 1 &&
          marked[0].properties._ff_promo_gift === marker &&
          marked[0].quantity === 1 &&
          marked[0].final_line_price === 0 &&
          discountMatches(marked[0], this.dataset.discountTitle);

        if (!exactDiscount) {
          await removeMarkedKeys(marked.map(function (item) { return item.key; }));
          throw new Error(this.dataset.discountError);
        }

        await refreshSurfaces(this.dataset.surface === 'drawer');
      } catch (error) {
        if (hasEnded(this)) {
          document.querySelectorAll('ff-free-tshirt').forEach(function (picker) {
            picker.dataset.hasMarkedGift = 'true';
            picker.dataset.checkoutSafe = 'false';
          });
          busy = false;
          await this.reconcile();
          return;
        }
        this.setStatus(error.message || this.dataset.unavailableError, true, false);
        try {
          await refreshSurfaces(this.dataset.surface === 'drawer');
        } catch (refreshError) {
          guardCheckout();
        }
      } finally {
        busy = false;
        if (document.contains(this)) this.setBusy(false);
        guardCheckout();
      }
    }
  }

  if (!customElements.get('ff-free-tshirt')) customElements.define('ff-free-tshirt', FFFreeTshirt);
  document.addEventListener('DOMContentLoaded', updateAllPickerStates);
  document.addEventListener('cart:change', function () {
    window.requestAnimationFrame(updateAllPickerStates);
  });
  window.addEventListener('pageshow', function () {
    updateAllPickerStates();
    document.querySelectorAll('ff-free-tshirt').forEach(function (picker) { picker.reconcile(); });
  });
})();

